import config from 'config'; // eslint-disable-line
import queryString from 'querystring';

export const getUrl = (resource, params) => {
  const query = params ? `?${queryString.stringify(params)}` : '';
  return `${config.api.host}/${resource}${query}`;
};

const call = (resource, method = 'GET', params, body = undefined) => {
  const url = getUrl(resource, params);

  let req = new Request(url, {
    mode: 'cors',
    method,
    headers: new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  });

  if (body) {
    req = new Request(req, {
      body: JSON.stringify(body),
    });
  }

  return req;
};

export const get = (resource, params) => call(resource, 'GET', params);

export const post = (resource, params, body) => call(resource, 'POST', params, body);

export const put = (resource, params, body) => call(resource, 'PUT', params, body);

export const patch = (resource, params, body) => call(resource, 'PATCH', params, body);



// WEBPACK FOOTER //
// ./src/utils/api.js